/* eslint-disable no-restricted-globals */
import { navigate } from 'gatsby'
import { store } from '@/store'
import { saveCart, create as fetchCart } from '@/store/cart'
import { fetchInstalledApps } from '@/store/installedApps'
import { fetchSubscription } from '@/store/subscription'
import { JSONParse } from '@/utils/func'
import { PM_EVENT } from '@/utils/postMessage/constants'
import { normalizeAAPath } from '@/utils/postMessage/utils'

import { trailingSlash, POST_MESSAGE_ORIGIN_WHITELIST } from '../regex'
import { canUseWindow } from './window'

const isValidEventOrigin = (event) => {
  const [originProtocol, originUrl] = event.origin.split('://')

  if (originProtocol !== 'https' && originProtocol !== 'http') {
    return false
  }

  return POST_MESSAGE_ORIGIN_WHITELIST.some((origin) => origin.test(originUrl))
}

// TODO: Remove after HD rewrite
export const initPostMessageListeners = () => {
  const receiveMessage = (event) => {
    if (isValidEventOrigin(event)) {
      handleAgentAppEvents(event)
    }
  }

  window.addEventListener('message', receiveMessage, false)
}

const handleAgentAppEvents = (event) => {
  const data = JSONParse(event.data)

  switch (data?.event_name) {
    case PM_EVENT.NAVIGATE: {
      const { pathname, replace = false } = data.event_data
      const normalizedPathname = normalizeAAPath(pathname)

      navigate(normalizedPathname, {
        replace:
          // Prevent doubled entry in browser history
          (canUseWindow &&
            window.location.pathname.replace(trailingSlash, '') ===
              normalizedPathname) ||
          replace,
      })
      break
    }

    case PM_EVENT.PRELOAD: {
      const pathname = normalizeAAPath(data.event_data.pathname)
      window?.___loader.loadPage(pathname)
      break
    }

    case PM_EVENT.REFRESH_INSTALLED_APPS: {
      store?.dispatch(fetchInstalledApps.pending())
      break
    }

    case PM_EVENT.CART_UPDATED: {
      const cart = data.event_data.cart
      store?.dispatch(saveCart(cart))
      break
    }

    case PM_EVENT.REFRESH_CART: {
      store?.dispatch(fetchCart.pending())
      break
    }

    case PM_EVENT.REFRESH_SUBSCRIPTION_INFO: {
      store?.dispatch(fetchSubscription.pending({ omitCache: true }))
      break
    }

    default:
      return false
  }
}
